import { I18n } from '@alife/cn-i18n';
import locale from './index';

export default new I18n({ locale, packageName: 'chatai-ui' });
